import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { FormControl, InputLabel, Grid, Input, Divider, Checkbox, FormControlLabel } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import inputComponentMask from "lib/inputMask";
import { StyledGrid } from "../Constants/StyledComponents";
import DropDownFormControl from "./Components/DropDownFormControl";
import DatePicker from "material-ui-pickers/DatePicker";
import * as DebtVal from "../Constants/DebtValuation";
import _ from 'lodash';
import moment from 'moment';
import InterestRateType from '../Constants/InterestRateType';
import './styles.css';

const styles = {
    dropDownList: {
        width: "150px"
    }
};

export const DebtValuationParams = {
    valuationDate: moment(),
    discountMethod: DebtVal.DiscountMethod[DebtVal.FLOATINGDISCOUNT].value,
    baseIndex: DebtVal.BaseIndex[DebtVal.TREASURYS].value,
    firstPeriodAccruals: DebtVal.FirstPeriodAccruals[DebtVal.ACCRUED].value,
    spreadType: DebtVal.SpreadType[DebtVal.DYNAMIC].value,
    loanTypeId: DebtVal.LoanTypes[DebtVal.LoanType].value,
    spreadInput: ""
}

class CashflowsDebtValuation extends Component {
    state = {...DebtValuationParams, interestRateType: undefined};
    constructor(props) {
        super(props);
        // this.state = props.state.DebtValuationParams;
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (prevState.interestRateType !== nextProps.state.interestRateType) {
          return {...nextProps.state.debtValuationParams, interestRateType: nextProps.state.interestRateType};
        }
    
        // Return null to indicate no change to state.
        return null;
    }    

    componentDidMount() {
        this.setState(this.props.state.debtValuationParams);
    }

    handleChange = (name) => e => {
        let newState = this.state;
        let value = e.target ? e.target.value : e;
        _.set(newState, name, value);
        this.setState(newState);

        this.props.handleChange({target: {name: "debtValuationParams", value: newState}})
    }

    onChecked = (e) => {
        this.handleChange("valuationDate")
        this.props.handleChange({target: {name: "hasDebtValuation", value: e.target.checked}})
    }

    renderOptionFields = () => {
        if(!this.props.state.hasDebtValuation) return;
        return (
            <Grid
                container
                spacing={8}
                alignItems="flex-start"
                justify="flex-start"
                direction="row"
            >
                <StyledGrid item xs={3} >
                    <FormControl className="selectMenu" >
                        <DatePicker
                            label="VALUATION DATE"
                            name="startDate"
                            format="MM/DD/YYYY"
                            value={this.state.valuationDate}
                            onChange={this.handleChange("valuationDate")}
                        />
                    </FormControl>
                </StyledGrid>
                <StyledGrid item xs={3}>
                        <DropDownFormControl
                            htmlFor="discountmethod"
                            labelName="Discount Method"
                            value={this.state.discountMethod}
                            onChange={this.handleChange("discountMethod")}
                            inputProps={{ name: "dayCount" }}
                            menuItemList={DebtVal.DiscountMethod}
                            menuItemDisabledList={this.props.state.interestRateType !== InterestRateType.FIXED_RATE ? ["ReplacementRate"] : []}
                        />
                    
                </StyledGrid>
                <StyledGrid item xs={3}>
                    {this.state.discountMethod === DebtVal.DiscountMethod[ DebtVal.REPLACEMENT ].value && <DropDownFormControl
                        htmlFor="baseIndex"
                        labelName="Base Index"
                        value={this.state.baseIndex}
                        onChange={this.handleChange("baseIndex")}
                        inputProps={{ name: "dayCount" }}
                        menuItemList={DebtVal.BaseIndex}
                        menuItemHiddenList={this.props.state.interestRateType !== InterestRateType.FIXED_RATE ? [ "Swaps" ] : []}
                    />}
                    {this.state.discountMethod === DebtVal.DiscountMethod[ DebtVal.FLOATINGDISCOUNT ].value && <DropDownFormControl
                        htmlFor="baseIndex"
                        labelName="Base Index"
                        value={this.state.baseIndex}
                        onChange={this.handleChange("baseIndex")}
                        inputProps={{ name: "dayCount" }}
                        menuItemList={DebtVal.FloatingIndex}
                    />}
                </StyledGrid>
                <StyledGrid item xs={3}>
                        <DropDownFormControl
                            htmlFor="daycount"
                            labelName="Day Count"
                            value={this.state.firstPeriodAccruals}
                            onChange={this.handleChange("firstPeriodAccruals")}
                            inputProps={{ name: "dayCount" }}
                            menuItemList={DebtVal.FirstPeriodAccruals}
                        />
                </StyledGrid>
                <StyledGrid item xs={3}>
                        <DropDownFormControl
                            htmlFor="loanType"
                            labelName="Loan Type"
                            value={this.state.loanTypeId}
                            onChange={this.handleChange("loanTypeId")}
                            inputProps={{ name: "loanTypes" }}
                            menuItemList={DebtVal.LoanTypes}
                        />
                </StyledGrid>
                <StyledGrid item xs={3}>
                    <FormControl className="selectMenu" >
                    <InputLabel htmlFor="ltv">LTV</InputLabel>
                        <Input
                            type="text"
                            name="ltv"
                            value={this.state.ltv}
                            onChange={this.handleChange("ltv")}
                            placeholder="Enter LTV"
                            
                        />
                    </FormControl>
                </StyledGrid>
                <StyledGrid item xs={3}>
                        <DropDownFormControl
                            htmlFor="daycount"
                            labelName="Spread Type"
                            value={this.state.spreadType}
                            onChange={this.handleChange("spreadType")}
                            inputProps={{ name: "dayCount" }}
                            menuItemList={DebtVal.SpreadType}
                        />
                </StyledGrid>
                {this.state.spreadType===DebtVal.SpreadType[DebtVal.SINGLE].value && <StyledGrid item xs={3}>
                    <FormControl className="selectMenu" >
                    <InputLabel htmlFor="spreadInput">SPREAD (%)</InputLabel>
                    <Input
                        type="text"
                        name="spreadInput"
                        value={this.state.spreadInput || ""}
                        onChange={this.handleChange("spreadInput")}
                        inputComponent={inputComponentMask({
                            mask: "percent"
                        })}
                        />
                    </FormControl>
                </StyledGrid>}
                

            </Grid>
        );
    }

    render() {

        return (
            <StyledGrid item xs={12}>
                <FormControlLabel 
                control={<Checkbox checked={this.props.state.hasDebtValuation} onChange={this.onChecked} />} 
                label="Calculate debt valuation" 
                labelPlacement="start" 
                style={{ paddingLeft: '15px' }} />
                {this.renderOptionFields()}
                <StyledGrid item xs={12}>
                    <Divider />
                </StyledGrid>
            </StyledGrid>
        )
    }
}

const mapStateToProps = ({ authentication }) => ({
    authentication
});

export default compose(
    connect(mapStateToProps),
    withStyles(styles)
)(CashflowsDebtValuation);
